// modles
import type {
  ReqCreateSystem,
  ReqSubSystems,
  ReqSystemCode,
  ReqSystemList,
  ReqUpdateSystem,
  ResSubSystems,
  ResSystems,
  ReqSystemSave,
  ReqSystemUpdate,
  SystemCode
} from '../models/system.model';
import type { BaseApiResponse, ResultBaseProps } from 'modules';

// services
import AxiosInstanceCreator from 'services/api';

// libraries
import { type AxiosInstance } from 'axios';

const systemInstance = new AxiosInstanceCreator().create();

export const systemApi = {
  /**
   * system 목록
   */
  async getSystems(clsCd: number | string): Promise<ResSystems> {
    return systemInstance.get(`/system?clsCd=${clsCd}&page=0&size=999`).then((res) => res.data);
  },

  /**
   * system code 추가
   * @param {clsCd, cdNm} data
   * @returns
   */
  async createSystem(data: ReqCreateSystem): Promise<ResultBaseProps> {
    return systemInstance.post(`/system`, data).then((res) => res.data);
  },

  /**
   * system code 수정
   * @param {systemId, cdNm} data
   * @returns
   */
  async updateSystem(data: ReqUpdateSystem): Promise<ResultBaseProps> {
    return systemInstance.post(`/system/modify`, data).then((res) => res.data);
  },

  /**
   * system code 삭제
   * @param {systemId} id
   * @returns
   */
  async deleteSystem(id: string): Promise<ResultBaseProps> {
    return systemInstance.delete(`/system/${id}`).then((res) => res.data);
  },

  /**
   * system 목록, 직책 조회
   * clsCd:2
   * @returns
   */
  async getDesignations(): Promise<ResSubSystems> {
    return systemInstance.get(`/system?clsCd=2&page=0&size=100`).then((res) => res.data);
  },

  /**
   * system 공종 조회
   * clsCd:3
   * @returns
   */
  async getDisciplines(): Promise<ResSubSystems> {
    return systemInstance.get(`/system?clsCd=3&page=0&size=100`).then((res) => res.data);
  },

  /**
   * system 목록
   */
  async getSubSystems(data: ReqSubSystems): Promise<ResSystems> {
    return systemInstance.get(`/system`, { data }).then((res) => res.data);
  },

  /** System Code */
  async getSystemCode(params: ReqSystemCode): Promise<ResSystems> {
    return systemInstance.get<ResSystems>(`/system`, { params }).then((res) => res.data);
  }
};

export class SystemAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  /** 시스템 세팅 조회 API */
  async getSystemList(params: ReqSystemList): Promise<BaseApiResponse<unknown, SystemCode>> {
    return await this.Axios.get<BaseApiResponse<unknown, SystemCode>>('/system', { params }).then(
      (res) => res.data
    );
  }

  /** 시스템 코드 추가 API */
  async saveSystemCode(params: ReqSystemSave): Promise<BaseApiResponse<SystemCode>> {
    return await this.Axios.post<BaseApiResponse<SystemCode>>('/system', params).then(
      (res) => res.data
    );
  }

  /** 시스템 코드 업데이트 API */
  async updateSystemCode(params: ReqSystemUpdate): Promise<BaseApiResponse<SystemCode>> {
    return await this.Axios.post<BaseApiResponse<SystemCode>>('/system/modify', params).then(
      (res) => res.data
    );
  }

  /** 시스템 세팅 조회 (Public) API */
  async getPublicSystemList(params: ReqSystemList): Promise<BaseApiResponse<unknown, SystemCode>> {
    return await this.Axios.get<BaseApiResponse<unknown, SystemCode>>('/system/public', {
      params
    }).then((res) => res.data);
  }

  /** 시스템 세팅 범위 조회 API */
  async getSystemListByRange(params: {
    clsCdStart?: number;
    clsCdLast?: number;
  }): Promise<BaseApiResponse<unknown, SystemCode>> {
    return await this.Axios.get<BaseApiResponse<unknown, SystemCode>>('/system/list', {
      params
    }).then((res) => res.data);
  }

  /** 시스템 세팅 삭제 API */
  async deleteSystemCode(systemId: string): Promise<BaseApiResponse<string>> {
    return await this.Axios.delete<BaseApiResponse<string>>(`/system/${systemId}`).then(
      (res) => res.data
    );
  }

  /** 안전교육 시스템 세팅 조회 API */
  async getSafetySystemList(params: ReqSystemList): Promise<BaseApiResponse<unknown, SystemCode>> {
    return await this.Axios.get<BaseApiResponse<unknown, SystemCode>>('/system/safety', {
      params
    }).then((res) => res.data);
  }

  /** 안전교육 시스템 코드 추가 API */
  async saveSafetySystemCode(params: ReqSystemSave): Promise<BaseApiResponse<SystemCode>> {
    return await this.Axios.post<BaseApiResponse<SystemCode>>('/system/safety', params).then(
      (res) => res.data
    );
  }

  /** 안전교육 시스템 코드 업데이트 API */
  async updateSafetySystemCode(params: ReqSystemUpdate): Promise<BaseApiResponse<SystemCode>> {
    return await this.Axios.post<BaseApiResponse<SystemCode>>('/system/safety/modify', params).then(
      (res) => res.data
    );
  }

  /** 안전교육 시스템 세팅 삭제 API */
  async deleteSafetySystemCode(systemId: string): Promise<BaseApiResponse<string>> {
    return await this.Axios.delete<BaseApiResponse<string>>(`/system/safety/${systemId}`).then(
      (res) => res.data
    );
  }
}
